<ui-page-header
  routeToIgnoreForBackNavigation="order"
  subtitle="In der Bestellübersicht können Sie Details zu Ihrer Bestellung einsehen. Wenn Sie die Bestellung erst kürzlich getätigt haben, kann sich die Anzeige verzögern."
>
  Bestellübersicht
</ui-page-header>

<div class="section-wrapper">
  <ui-order-history-filter-sort
    (filterChange)="onFilterChanged($event)"
    (sortChange)="onSortOrder($event)"
    [filter]="this.searchParams().filter"
    [sort]="sort()"
  ></ui-order-history-filter-sort>

  @if (orderHistoryResource.isLoading()) {
    @if (isDesktop()) {
      <ui-order-history-desktop-skeleton></ui-order-history-desktop-skeleton>
    } @else {
      <ui-order-history-mobile-skeleton></ui-order-history-mobile-skeleton>
    }
  } @else if (orderHistoryResource.error()) {
    <ui-alert theme="error" message="Beim Laden der Bestellungen ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal."></ui-alert>
  } @else {
    @if (orders().length >= 1) {
      @if (isDesktop()) {
        <ui-order-history-desktop [orders]="orders()"></ui-order-history-desktop>
      } @else {
        <ui-order-history-mobile [orders]="orders()"></ui-order-history-mobile>
      }

      @if (orderHistory()?.pagination; as pagination) {
        <ui-paginator
          [pageIndex]="(this.page() ?? 1) - 1"
          [length]="pagination.count"
          [pageSize]="limit()"
          [pageSizeOptions]="pagination.limits"
          [showFirstLastButtons]="true"
          (page)="onPagination($event)"
        ></ui-paginator>
      }
    } @else {
      <div class="no-orders-container">
        <ui-icon faName="empty-set" faStyle="light"></ui-icon>
        <h1>Keine Bestellungen</h1>
        <p>Es wurden keine Bestellungen gefunden.</p>
      </div>
    }
  }
</div>
